import { CloudHubSettingsState } from './model'
import { ActionType, SettingsCloudHubActions } from './actions'

const environmentSelectorInitialState = {
  environments: undefined,
  selected: undefined,
  isLoading: true
}

const resourceListInitialState = {
  resources: undefined,
  filteredResources: undefined,
  isLoading: false
}

const cloudHubDeploymentInitialState = {
  isLoading: true,
  isChanging: true,
  deployment: {
    newAppsAgentEnabled: undefined
  }
}

const initialState: CloudHubSettingsState = <CloudHubSettingsState> {
  environmentSelector: environmentSelectorInitialState,
  resourceList: resourceListInitialState,
  cloudHubDeployment: cloudHubDeploymentInitialState,
  applyStatus: undefined
}

const reducer = (state: CloudHubSettingsState = initialState, action: SettingsCloudHubActions): CloudHubSettingsState => {
  switch (action.type) {
    case ActionType.FetchEnvironments:
      return {...state, environmentSelector: environmentSelectorInitialState}

    case ActionType.FetchedEnvironments:
      const fetchedEnvironmentsSelector = {environments: action.payload.environments, selected: undefined, isLoading: false}
      return {...state, environmentSelector: fetchedEnvironmentsSelector}

    case ActionType.EnvironmentSelected:
      const environments = state.environmentSelector.environments
      const environmentSelected = environments && environments.find((env) => env.id === action.payload.environmentId)
      const environmentSelectedSelector = {selected: environmentSelected, isLoading: false, environments}
      return {...state, environmentSelector: environmentSelectedSelector}

    case ActionType.FetchResources:
      const fetchResourceList = {resources: undefined, filteredResources: undefined, isLoading: true}
      return {...state, resourceList: fetchResourceList}

    case ActionType.FetchedResources:
      const fetchedResources = {resources: action.payload.resources, filteredResources: action.payload.resources, isLoading: false}
      return {...state, resourceList: fetchedResources}
    
    case ActionType.FetchedCloudHubSettings:
      return {...state, cloudHubDeployment: action.payload.settings}

    case ActionType.FilteredResources:
      const filteredResourceList = {...state.resourceList, filteredResources: action.payload.filteredResources, isLoading: false}
      return {...state, resourceList: filteredResourceList}

    case ActionType.ApplySuccess:
      const applyStatusSuccess = {success: true, apply: action.payload.apply, timestamp: new Date(), application: action.payload.application}
      return {...state, applyStatus: applyStatusSuccess}

    case ActionType.ApplyError:
      const applyStatusError = {success: false, apply: action.payload.apply, timestamp: new Date(), application: action.payload.application}
      return {...state, applyStatus: applyStatusError}
    
    case ActionType.EnableMonitoringError:
      const statusError = {success: false, apply: action.payload.apply, timestamp: new Date()}
      return {...state, enableMonitoringStatus: statusError}

    case ActionType.ChangeQuery:
      return {...state, query: action.payload.query}

    default:
      return state
  }
}

export default reducer
